import React from 'react';
import { useRouter } from 'next/router';
import JobList from '@components/position/jd/positionJob/jobList';

import { useMatchingJob } from '@repository/position/usePosition';
import classnames from 'classnames/bind';
import styles from './positionJob.module.scss';
const cx = classnames.bind(styles);

const PositionJob = () => {
  const { query } = useRouter();
  const positionSn = Number(query.sn);
  const { data: positionJobList, isLoading } = useMatchingJob(positionSn, 6);

  if (!positionJobList?.positions || isLoading) return null;
  if (positionJobList?.positions?.length === 0) return null;

  return (
    <div className={cx('positionWrap')}>
      <em className={cx('title')}>
        <span className={cx('text')}>보고 계신 포지션과</span> 비슷한 포지션이에요.
      </em>

      <JobList positions={positionJobList.positions} />
    </div>
  );
};

export default PositionJob;
